import { isValid } from 'date-fns'

import { EMPTY_VALUE } from '@/constants/ui'

import { formatTimeOnly } from './format-time-only'

// Note: Format is -> 02:30 PM - 04:00 PM
export const formatTimeRange = (
  start: Date | string | null | undefined,
  end: Date | string | null | undefined,
  timezone?: string,
): string => {
  if (!start || !end) return EMPTY_VALUE

  const startDate = start instanceof Date ? start : new Date(start)
  const endDate = end instanceof Date ? end : new Date(end)

  if (!isValid(startDate) || !isValid(endDate)) return EMPTY_VALUE

  return `${formatTimeOnly(startDate, timezone)} - ${formatTimeOnly(endDate, timezone)}`
}
